import { Box, Tooltip, Typography } from "@mui/material";
import { MouseEventHandler } from "react";
import { optionStyleProps } from "../theme/main";

export type OptionProps = {
  title?: string;
  subTitle?: string;
  toolTip?: string;
  selected?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
  backgroundImage?: string;
};

export function Option({
  title,
  subTitle,
  toolTip,
  selected = false,
  onClick,
  backgroundImage,
}: OptionProps) {
  let { selectedStyle, ...optionStyle } = optionStyleProps;

  return (
    <Tooltip title={toolTip}>
      <Box>
        <Box
          sx={{
            ...optionStyle,
            ...(selected ? selectedStyle : {}),
            backgroundImage: backgroundImage,
            cursor: "pointer",
          }}
          onClick={onClick}
        ></Box>
        {title && <Typography>{title}</Typography>}
        {subTitle && <Typography>{subTitle}</Typography>}
      </Box>
    </Tooltip>
  );
}
